export const Delimiter = () => (
  <div className={`mt-2 mb-2 border-[#F0F2F3] border-[2px] border-solid`}></div>
);
